import { useSyncExternalStore } from 'react';
import alertFocusStore from '../../store/AlertFocusStore';

export const useAlertFocus = (): ReturnType<typeof alertFocusStore.getState> => useSyncExternalStore(
  alertFocusStore.subscribe,
  alertFocusStore.getState,
  alertFocusStore.getState,
);
